import useTicket from "@/hooks/useTicket";
import RechargeFinishedView from "./view";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { getFormattedCart } from "@/utils/functions";
import { useState, useEffect } from "react";

export default function RechargeFinished() {
  const navigate = useNavigate();
  const { 
    isLoading, 
    getTickets, 
    getInvoice, 
    generatePDF,
    invoice,
    toggleModal,
    isVisibleModal,
    customer,
  } = useTicket();

  const [error, setError] = useState<boolean>(false);
  const [shouldProcessTickets, setShouldProcessTickets] = useState<boolean>(false);

  const toggleError = () => setError(prev => !prev);

  const goBack = () => gotToHome();

  const gotToHome = () => navigate("/");

  useEffect(() => {
    if (shouldProcessTickets && customer?.tickets && customer.tickets.length > 0 && !isLoading) {
      setShouldProcessTickets(false);
      processTicketsAndOpenInvoice();
    }
  }, [customer?.tickets, shouldProcessTickets, isLoading]);

  const processTicketsAndOpenInvoice = () => {
    const currentTickets = customer?.tickets;
    const { total } = getFormattedCart({ cart: customer?.cart!, debts: customer?.debts! });
 
    if (!currentTickets || currentTickets.length === 0) {
      toggleError();
      return;
    }
    
    const filteredItems = currentTickets?.filter(item => {
      const itemPrice = Number(item.price.replace(/,/g, '.'));
      const isPriceMatch = Math.abs(itemPrice - total) < 0.10;
      const isWithinTimeLimit = moment(item.fullDate).isAfter(moment().subtract(10, 'minutes'));
      
    
      return isPriceMatch && isWithinTimeLimit;
    }) ?? [];
    
    
    if (filteredItems.length === 0) {
      const recentTickets = currentTickets?.filter(item => 
        moment(item.fullDate).isAfter(moment().subtract(10, 'minutes'))
      ) ?? [];

      if (recentTickets.length > 0) {
        const sortedRecentTickets = recentTickets.sort((a, b) => {
          const priceDiffA = Math.abs(Number(a.price.replace(/,/g, '.')) - total);
          const priceDiffB = Math.abs(Number(b.price.replace(/,/g, '.')) - total);
          
          if (priceDiffA !== priceDiffB) {
            return priceDiffA - priceDiffB;
          }
          
          const dateA = moment(a?.fullDate);
          const dateB = moment(b?.fullDate);
          return dateB.diff(dateA);
        });
        
        getInvoice({
          id: sortedRecentTickets[0].id,
          date: sortedRecentTickets[0].date,
          price: sortedRecentTickets[0].price,
          status: sortedRecentTickets[0].status
        });
        return;
      }
    }
    
    const sortedTickets = [...filteredItems]?.sort((a, b) => {
      const dateA = moment(a?.fullDate);
      const dateB = moment(b?.fullDate);
      return dateB.diff(dateA);
    });
    
    if (!sortedTickets?.length) {
      toggleError();
      return;
    }
    
    getInvoice({
      id: sortedTickets[0].id,
      date: sortedTickets[0].date,
      price: sortedTickets[0].price,
      status: sortedTickets[0].status
    });
  };

  const openInvoice = () => {
    setShouldProcessTickets(true);
    getTickets();
  }

  return (
    <RechargeFinishedView
      goBack={goBack}
      gotToHome={gotToHome}
      invoice={invoice}
      toggleModal={toggleModal}
      generatePDF={generatePDF}
      isVisibleModal={isVisibleModal}
      isLoading={isLoading}
      openInvoice={openInvoice}
      error={error}
      toggleError={toggleError}
    />
  );
}
